import React, { Fragment, useEffect, useState } from "react"
import { connect } from "react-redux"
import { Container, Grid, Typography, Box, Fade } from "@material-ui/core"
import { withStyles } from "@material-ui/styles"
import styles from "./styles"
import { getPosts } from "actions/posts"
import AppCard from "components/AppCard"
import PostLoading from "components/PostLoading"
import noPostsImg from "assets/no-posts-img.svg"
import InfiniteScroll from "react-infinite-scroll-component"

const Submitted = ({ dispatch, posts, isLoading, classes }) => {
  const [postsPerPage, setPostsPerPage] = useState([])

  useEffect(() => {
    dispatch(getPosts("app-submitted"))
    setPostsPerPage(posts.slice(0, 12))
  }, [])

  // const sortedPosts = useMemo(() => {
  //   return posts.reverse()
  // }, [posts])

  const fetchMoreData = () => {
    setPostsPerPage(posts.slice(0, postsPerPage.length + 12))
  }
  useEffect(() => {
    setPostsPerPage(posts.slice(0, 12))
  }, [posts])

  return (
    <Fragment>
      <Container>
        <Typography variant="h2" className={classes.submittedTitle}>
          My Submitted
        </Typography>
        <Grid className={classes.gridContainer} container>
          {isLoading && <PostLoading />}
          {Boolean(postsPerPage.length) &&
            postsPerPage.map(post => (
              <Fragment key={post.id}>
                <InfiniteScroll
                  className={classes.infiniteScroll}
                  dataLength={postsPerPage.length}
                  next={fetchMoreData}
                  hasMore="true"
                  // loader={<h4>Loading...</h4>}
                  endMessage={
                    <p style={{ textAlign: "center" }}>
                      <b>Yay! You have seen it all</b>
                    </p>
                  }
                >
                  <AppCard post={post} />
                </InfiniteScroll>
              </Fragment>
            ))}
          {!posts.length && !isLoading && (
            <Fade in timeout={500}>
              <Box
                className={classes.noPostsContainer}
                display="flex"
                justifyContent="center"
                flexDirection="column"
              >
                <img src={noPostsImg} />
                <Typography className={classes.noPostsText} color="primary">
                  No Posts Found
                </Typography>
              </Box>
            </Fade>
          )}
        </Grid>
      </Container>
    </Fragment>
  )
}

const mapStateToProps = state => {
  return {
    data: state.dialogsContainerDialog.data,
    posts: state.posts.data,
    isLoading: state.posts.isLoading
  }
}

const connector = connect(mapStateToProps)

export default connector(withStyles(styles)(Submitted))



// WEBPACK FOOTER //
// ./src/pages/App/Submitted/index.js